import { render, staticRenderFns } from "./DashboardTransactionsBetweenAccounts.vue?vue&type=template&id=9ac56a5a"
import script from "./DashboardTransactionsBetweenAccounts.vue?vue&type=script&lang=js"
export * from "./DashboardTransactionsBetweenAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports